<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <account-header settingName="Profile"></account-header>
    <div class="row justify-center">
      <div class="col-lg-2"></div>
      <div class="col-lg-8">
        <h3 class="mt-4">My Profile Details</h3>
        <div class="row mt-4 mb-4">
          <div class="col-md-12">
            <form>
              <div class="form-group row">
                <label for="username" class="col-4 col-form-label" >User Name*</label>
                <div class="col-8">
                  <input
                    id="username"
                    name="username"
                    placeholder="Username"
                    class="form-control here"
                    required="required"
                    type="text"
                    v-model="userDetails.userName"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="name" class="col-4 col-form-label" >First Name</label>
                <div class="col-8">
                  <input
                    id="name"
                    name="name"
                    placeholder="First Name"
                    class="form-control here"
                    type="text"
                    v-model="userDetails.firstName"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="lastname" class="col-4 col-form-label" >Last Name</label>
                <div class="col-8">
                  <input
                    id="lastname"
                    name="lastname"
                    placeholder="Last Name"
                    class="form-control here"
                    type="text"
                    v-model="userDetails.lastName" 
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="text" class="col-4 col-form-label" >Nick Name*</label>
                <div class="col-8">
                  <input
                    id="text"
                    name="text"
                    placeholder="Nick Name"
                    class="form-control here"
                    required="required"
                    type="text"
                    v-model="userDetails.nickName"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label for="email" class="col-4 col-form-label" >Email*</label>
                <div class="col-8">
                  <input
                    id="email"
                    name="email"
                    placeholder="Email"
                    class="form-control here"
                    required="required"
                    type="text"
                    v-model="userDetails.email"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="website" class="col-4 col-form-label" >Website</label>
                <div class="col-8">
                  <input
                    id="website"
                    name="website"
                    placeholder="website"
                    class="form-control here"
                    type="text"
                    v-model="userDetails.website"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="publicinfo" class="col-4 col-form-label" >Public Info</label>
                <div class="col-8">
                  <textarea
                    id="publicinfo"
                    name="publicinfo"
                    cols="40"
                    rows="4"
                    class="form-control"
                    v-model="userDetails.publicInfo"
                  ></textarea>
                </div>
              </div>
              <div class="form-group row">
                <label for="newpass" class="col-4 col-form-label" >New Password</label>
                <div class="col-8">
                  <input
                    id="newpass"
                    name="newpass"
                    placeholder="New Password"
                    class="form-control here"
                    type="text"
                    v-model="userDetails.newPassword"
                  >
                </div>
              </div>
              <div class="form-group row">
                <div class="offset-4 col-8">
                  <button name="submit" type="submit" class="btn btn-primary">Update My Profile</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Constants from '@/common/Constants.js'
import accountHeader from "@/components/accountHeader.vue";
export default {
  name: "Rooms",
  components: { "account-header": accountHeader },
  data(){
    return{
      userDetails: {
        userName : '',
        firstName: '',
        lastName: '',
        nickName: '',
        email: '',
        website: '',
        publicInfo: '',
        newPassword: ''
      },

    }
  },
  mounted() {
    this.getUserDetails().then(data => {
      this.userDetails.email = data.email;
      this.userDetails.userName = data.name;

    	// console.log(data.name);
    })
    .catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
    });
  },

  methods: {
    getUserDetails: function(){
      let def = $.Deferred();
      let userDetails = JSON.parse(localStorage.user);
      let url = Constants.API_USER_DETAILS_URL+ userDetails.id;

      this.$http.get(url, { headers: { Authorization: "Bearer " +  localStorage.userToken }})
      .then((response) => {
        console.log(response);
        def.resolve(response.data.details);
      })
      .catch(function (error) {
        if (error.response) {
          def.reject(error);
        }
      });

      return def.promise();

    }
  }

  // components: {
  //   headerNav
  // }
};
</script>
